import { api } from "./api";

/**
 * A12 — client-side wrapper for the global address book at `/api/addresses`.
 *
 * Used by the order wizard search box + save-to-book flow. The admin
 * addresses page has its own thin wrapper (`modules/addresses/services/adminAddresses.js`)
 * kept separate so admin-only CRUD stays scoped to that module.
 */
const BASE = "/addresses";

export const addressesService = {
  /** GET /api/addresses — any authenticated user. */
  list: async (params) => (await api.get(BASE, { params })).data,

  /** POST /api/addresses — any authenticated user. Backend sets `created_by`. */
  create: async (payload) => (await api.post(BASE, payload)).data,
};
